module.exports = __webpack_public_path__ + "static/media/PALOMITA-47.25c49866.png";